export default __webpack_public_path__ + "static/media/pvilla3-2.dc5e5c79.webp";